module.exports = __webpack_public_path__ + "assets/img/social/reddit-icon.0678d3eb969635aca799803e490a535f.svg";